import { RawEventRow } from '@kentik/ui-shared/query/query.types';
import { Model } from 'core/model/Model';

type RawEventAttributes = RawEventRow & { id: string };

export default class RawEventModel extends Model<RawEventAttributes> {}
